import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetCertificationUserCounts = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['certificationUserCounts'],
    queryFn: () => analyticsService.getCertificationUserCounts(),
    refetchOnWindowFocus: false,
  });
};

export const useGetStudentsCount = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsStudentsCount'],
    queryFn: () => analyticsService.getStudentsCount(),
    refetchOnWindowFocus: false,
  });
};

export const useGetOrganizationsSummary = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsOrganizationsSummary'],
    queryFn: () => analyticsService.getOrganizationsSummary(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetWebinarsSummary = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsWebinarsSummary'],
    queryFn: () => analyticsService.getWebinarsSummary(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetActiveSubscriptionsKpi = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsActiveSubscriptionsKpi'],
    queryFn: () => analyticsService.getActiveSubscriptionsKpi(),
    refetchOnWindowFocus: false,
  });
};


export const useGetMasterCertifiedCount = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMasterCertifiedCount'],
    queryFn: () => analyticsService.getMasterCertifiedCount(),
    refetchOnWindowFocus: false,
  });
};